import request from 'utils/request'

export function setLanguage(userId, lang) {
  return request(`users/language/${userId}/${lang}`, {
    method: 'GET'
  })
}
